"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _feature.default;
  }
});
require("@webex/internal-plugin-mercury");
var _webexCore = require("@webex/webex-core");
var _feature = _interopRequireDefault(require("./feature"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerInternalPlugin)('feature', _feature.default, {
  config: _config.default
});
//# sourceMappingURL=index.js.map
